import React, { Component } from 'react';

class StepperItem extends Component {
  onClick = () => {
    if (!this.props.disable) {
      this.props.onClick && this.props.onClick();
    }
  };

  render() {
    let className = this.props.active ? 'StepperItem Active' : 'StepperItem';
    if (this.props.disable) {
      className += ' Disable';
    }

    return (
      <div
        className={className}
        onClick={this.onClick}
      >
        {`ステップ ${this.props.num}`}
      </div>
    );
  }
};

export default StepperItem;
